import { listUserMetrics } from 'src/graphql/queries';
import { UserMetricsDetail } from 'src/API';
import { formatApiError } from 'src/utils/errorUtils';
import { logger } from 'src/utils/logger';
import { fetchGraphQLRequest } from 'src/services/api/clients/graphqlClient';

/**
 *
 */
export const fetchUserMetricsAPI = async (): Promise<UserMetricsDetail[]> => {
  try {
    logger.info('Fetching user metrics from GraphQL API');
    const result = await fetchGraphQLRequest<{ listUserMetrics: UserMetricsDetail[] }>({
      query: listUserMetrics,
      variables: {},
      requestName: 'listUserMetrics',
      requestType: 'query',
    });

    const userMetrics = result.listUserMetrics || [];
    logger.info(`Fetched ${userMetrics.length} user metrics from API`);
    return userMetrics;
  } catch (error) {
    logger.error('Error fetching user metrics from GraphQL API:', { error });
    throw formatApiError('Failed to fetch user metrics', error);
  }
};
